// FETCH ALL PROPERTIES FROM HSN MASTER
export const FETCH_HSN_MASTER_REQUEST = 'FETCH_HSN_MASTER_REQUEST';
export const FETCH_HSN_MASTER_SUCCESS = 'FETCH_HSN_MASTER_SUCCESS';
export const FETCH_HSN_MASTER_FAILURE = 'FETCH_HSN_MASTER_FAILURE';

// FETCH ALL HSN LIST FROM HSN MASTER
export const FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST = 'FETCH_HSN_LIST_FROM_HSN_MASTER_REQUEST';
export const FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS = 'FETCH_HSN_LIST_FROM_HSN_MASTER_SUCCESS';
export const FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE = 'FETCH_HSN_LIST_FROM_HSN_MASTER_FAILURE';

// CREATE PROPERTIES FOR HSN MASTER
export const CREATE_HSN_MASTER_REQUEST = 'CREATE_HSN_MASTER_REQUEST';
export const CREATE_HSN_MASTER_SUCCESS = 'CREATE_HSN_MASTER_SUCCESS';
export const CREATE_HSN_MASTER_FAILURE = 'CREATE_HSN_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_HSN_MASTER = 'CREATE_USER_FORM_HSN_MASTER';

// UPDATE PROPERTIES FOR HSN MASTER
export const UPDATE_HSN_MASTER_REQUEST = 'UPDATE_HSN_MASTER_REQUEST';
export const UPDATE_HSN_MASTER_SUCCESS = 'UPDATE_HSN_MASTER_SUCCESS';
export const UPDATE_HSN_MASTER_FAILURE = 'UPDATE_HSN_MASTER_FAILURE';

// FETCH SINGLE HSN
export const FETCH_SINGLE_HSN_MASTER_REQUEST = 'FETCH_SINGLE_HSN_MASTER_REQUEST';
export const FETCH_SINGLE_HSN_MASTER_SUCCESS = 'FETCH_SINGLE_HSN_MASTER_SUCCESS';
export const FETCH_SINGLE_HSN_MASTER_FAILURE = 'FETCH_SINGLE_HSN_MASTER_FAILURE';

// DELETE PROPERTIES FOR HSN MASTER
export const DELETE_HSN_MASTER_REQUEST = 'DELETE_HSN_MASTER_REQUEST';
export const DELETE_HSN_MASTER_SUCCESS = 'DELETE_HSN_MASTER_SUCCESS';
export const DELETE_HSN_MASTER_FAILURE = 'DELETE_HSN_MASTER_FAILURE';

// USERFORM RESET

export const HSN_MASTER_USERFORM_RESET = 'HSN_MASTER_USERFORM_RESET';
export const GENERAL_HSN_MODAL_OPEN = 'GENERAL_HSN_MODAL_OPEN';

